import { TRADER_API } from "../constants/api";
import { GetTraderParamModel, GetTraderStatusParamModel } from "../model/common";
import { getHeadersWithTokenAndTraderId, getHeadersWithTokenOnly, getUrl, optionsGet } from "./commonService";
import customAxios from "./customAxios";

export default class TraderService {
  getTradersService(params: GetTraderParamModel) {
    const url = getUrl(TRADER_API.LIST);
    const headers = getHeadersWithTokenOnly(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
  getTraderStatusService(params: GetTraderStatusParamModel) {

     let api = TRADER_API.LIVE;
     api = api.replace("#TRADERID#", params.traderId.toString());

    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
}
